/**
 * CAFM utility functions class
 * 
 * @class Util
 */
export class Util {

    static get hiddenPreElement() { return document.createElement('pre'); }
    static get swipe() { return Util._swipeHelpers(); }
    
    static _swipeHelpers() {
        return {
            setupSwipeNav: function (e) {

                let targ = isJQuery(e.target) ? e.target : $('#{0}'.format(e.target));

                // handler for mouse swipe
                targ.on('mousedown', function (ev) {

                    window.downX = ev.pageX;
                });
                targ.on('mouseup', function (ev) {

                    cafm.util.swipe.swipeUp({
                        downX: window.downX,
                        upX: ev.pageX,
                        forward: e.forward,
                        backward: e.backward
                    });
                });

                // handlers for touch screen swipe
                targ.bind('touchstart.sn', function (ev) {

                    window.downX = ev.originalEvent.touches[0].pageX;
                });
                targ.bind('touchmove.sn', function (ev) {

                    if (isUndefined(e.preventDefault) || e.preventDefault) {

                        ev.preventDefault();
                    }
                    window.upX = ev.originalEvent.touches[0].pageX;
                });
                targ.bind('touchend.sn', function (ev) {

                    cafm.util.swipe.swipeUp({
                        downX: window.downX,
                        upX: window.upX,
                        forward: e.forward,
                        backward: e.backward
                    });

                    delete window.upX;
                    delete window.downX;
                });
            },
            swipeUp: function (e) {

                let diff = e.upX - e.downX;

                if (diff < -75 && isFunc(e.backward)) {
                    e.backward();
                }
                if (diff > 75 && isFunc(e.forward)) {
                    e.forward();
                }
            },
            swipeVerticalScroll: function (e) {

                let target = e.target;

                if (!isJQuery(target)) {

                    target = $(target);
                }

                target.bind('touchstart.vscroll', function (ev) {

                    target.data('downY', ev.originalEvent.touches[0].pageY);
                });
                target.bind('touchmove.vscroll', function (ev) {

                    ev.preventDefault();

                    let downY = target.data('downY');
                    let moveY = ev.originalEvent.touches[0].pageY;

                    let touchDiff = (moveY - downY) * 1.5;
                    if (touchDiff > 25 || touchDiff < -25) {

                        let currentTop = target.scrollTop();
                        target.stop().animate({ scrollTop: currentTop - touchDiff });
                    }
                });
                target.bind('touchend.vscroll', function (ev) {

                    target.removeData('downY');
                });
            }
        };
    }

    /**
     * Transforms array items into a new array using the delegate function argument
     * @param {Array} a The array to transform
     * @param {Function} f The transform function
     * @return {Array} The transformed array
     */
    static transformArray(a, f) {

        if (!a) return null;

        if (isFunc(a.toJSON)) {

            a = a.toJSON();
        }

        if (isArray(a)) {
            let selectItems = [];
            for (let i = 0; i < a.length; i++) {
                if (isFunc(i))
                    continue;
                selectItems.push(f(a[i]));
            }
            return selectItems;
        }
        else {
            return a;
        }
    }

    /**
     * Compares all the items in two arrays for equality
     * @param {Array} array1 The 1st array to compare
     * @param {Array} array2 The other array to compare
     * @return {Boolean} True if all items are equal
     */
    static arraysAreEqual(array1, array2) {

        // if the other array is a falsy value, return
        if (!array1) {

            return false;
        }

        // compare lengths - can save a lot of time
        if (array1.length !== array2.length) {

            return false;
        }

        for (let i = 0, l = array1.length; i < l; i++) {

            // check if we have nested arrays
            if (array1[i] instanceof Array && array2[i] instanceof Array) {

                // recurse into the nested arrays
                if (!cafm.util.arraysAreEqual(array1[i], array2[i])) {

                    return false;
                }
            }
            else if (array1[i] !== array2[i]) {

                return false;
            }
        }

        return true;
    }

    /**
     * Determine if an array contains a value or object or not
     * @param {Array} arr The array to test
     * @param {Object} o The object to test for
     * @return {Boolean} True if the object is equal to an item in the array
     */
    static arrayContains(arr, o) {
        if (!arr) return false;
        return arr.indexOf(o) > -1;
    }


    /**
     * Selects distinct values from an array of uses an equality function to test the items
     * @param {Array} arr The array to test
     * @param {Function} func The equality function
     * @return {Array} Array of distinct results
     */
    static selectDistinct(arr, func) {

        let result = [];

        $.each(arr, (i, item) => {

            let hasFunc = isFunc(func);
            if ((!hasFunc && $.inArray(item, result) == -1) || (hasFunc && func(item))) {

                result.push(item);
            }
        });

        return result;
    }

    /**
    * Traverses an array items and extracts a specific property into a new array
    * @param {Array} a The array to traverse
    * @param {String} p The name of the property to extract
    * @param {Boolean} f Fallback to item if property is null or undefined flag
    * @return {Array} The new array containing the selected property values
    */
    static selectValue (a, p, f) {

        return cafm.util.transformArray(a, i => {

            let v = i[p];

            if (f === true && !v) {

                v = i;
            }

            return v;
        });
    }

    /**
     * Gets the index of an item in an array using the delegate function argument
     * @param {Array} a The array to search
     * @param {Function} f The delegate function
     * @return {Number} Returns the index of the first match
     */
    static indexOf(a, f) {

        for (let i = 0; i < a.length; i++) {
            if (isFunc(a[i]))
                continue;
            let item = a[i];
            if (f(item))
                return i;
        }
        return -1;
    }

   /**
    * Matches the first item in an object using the delegate function argument
    * @param {Object} o The object to search
    * @param {Function} f The delegate test function
    * @param {Boolean} includeFuncs Flag determining whether to include functions in the find operation or not - optional, default is false
    * @return {Object} Returns the first matched object
    */
    static find(o, f, includeFuncs) {

        if (!o) return null;

        for (let k in o) {

            let i = o[k];
            if (isFunc(i) && !includeFuncs)
                continue;
            if (f(i, k))
                return i;
        }
        return null;
    }

    /**
    * Matches the first item that matches the field value for the specified field
    * @param {Array} array The array to search
    * @param {String} fieldName The field name
    * @param {Object} fieldValue Field value
    * @return {Object} Returns the first matched object
    */
    static findByFieldValue(array, fieldName, fieldValue) {

        if (!array) return null;

        let match;
        array.forEach(obj => {

            let v = fieldName ? cafm.util.getReference(fieldName, obj) : obj;

            if (!match && v === fieldValue) {

                match = obj;
            }
        });

        return match || null;
    }

    /**
    * Counts the number of items in an object using the delegate function argument
    * @param {Object} o The object to search
    * @param {Function} f The delegate function
    * @return {Number} Returns the number of matches
    */
    static count(o, f) {

        let items = cafm.util.where(o, f);
        return items ? items.length : 0;
    }

    /**
    * Determines if an item exists in an object using the delegate function argument
    * @param {Object} o The object to search
    * @param {Object} f The delegate test function or a specific value to check an item is equal to
    * @return {Boolean} Returns true if the delgate function determines that the object exists
    */
    static exists(o, f) {

        for (let k in o) {
            let i = o[k];
            if (isFunc(i))
                continue;
            if (isFunc(f) && f(i))
                return true;
            else if (f == i)
                return true;
        }
        return false;
    }

    /**
     * Determines if an item exists with a specific field value
     * @param {Array} array The array to search
     * @param {String} fieldName The field name
     * @param {Object} fieldValue The field value
     * @return {Boolean} Returns true if there is an item with the specified field value
     */
    static existsByFieldValue(array, fieldName, fieldValue) {

        if (!array) return null;

        let matches = [];
        let exists;
        array.forEach(obj => {
            let v = cafm.util.getReference(fieldName, obj);
            if (v === fieldValue)
                exists = true;
        });

        return exists;
    }

   /**
    * Matches the items in an object using the delegate function argument
    * @param {Object} o The object to search
    * @param {Function} f The delegate test function
    * @return {Array} Returns an array of matched objects
    */
    static where(o, f) {

        let matches = [];
        for (let k in o) {
            let i = o[k];
            if (isFunc(i))
                continue;
            if (f(i))
                matches.push(i);
        }
        return matches;
    }

   /**
    * Matches the items that matches the field value for the field
    * @param {Array} array The array to search
    * @param {String} fieldName The field name
    * @param {Object} fieldValue The field value
    * @return {Object} Returns an array of matched objects
    */
    static whereByFieldValue(array, fieldName, fieldValue) {

        if (!array) return null;

        let matches = [];
        array.forEach(obj => {

            let v = cafm.util.getReference(fieldName, obj);

            if (v === fieldValue) {

                matches.push(obj);
            }
        });

        return matches;
    }

   /**
    * Removes the items in an array using the delegate function argument
    * @param {Object} o The array to search
    * @param {Function} f The delegate test function
    * @return {Number} Returns number of items removed
    */
    static removeWhere(o, f) {

        let toRemove = [];
        for (let i = 0; i < o.length; i++) {
            let it = o[i];
            if (isFunc(it))
                continue;
            if (f(it)) {
                toRemove.push(i);
            }
        }
        let numRemoved = 0;
        for (let i = 0; i < toRemove.length; i++) {

            let index = toRemove[i];
            o.splice(index - numRemoved, 1);
            numRemoved++;
        }

        return numRemoved;
    }

    /**
     * Adds all items from array one array to another
     * @param {Array} array1 The array to add to
     * @param {Array} array2 The array to add to the other array
     * @return {Array} Returns combined array or false if array is not an array
     */
    static addAll(array1, array2) {

        if (!isArray(array1)) {

            return false;
        }
        else if (!isArray(array2)) {

            return array1;
        }
        else {

            for (let i = 0; i < array2.length; i++) {

                array1.push(array2[i]);
            }

            return array1;
        }
    }

    /**
     * Determines if a string is not empty/null/undefined
     * @param {String} o The string to test
     * @return {Boolean} Returns true if the string has a value
     */
    static hasStringVal(o) {

        return isDefined(o) && isStr(o) && o != '' && o != 'undefined' && o != null && o != 'null' && o.trim().length > 0;
    }

    /**
     * Converts an array to a UL tag string
     * @param {Object} arr The array or string
     * @return {String} Returns a HTML string
     */
    static toUlString(arr) {
        
        if (arr && isStr(arr)) {

            // check for unencoded line breaks
            if (arr.indexOf('\r\n') > -1) {

                arr = arr.split(/\r\n/g);
            }
            // check for encoded line breaks
            else if (arr.indexOf('&#13;&#10;') > -1) {

                arr = arr.split(/&#13;&#10;/g);
            }
            else {

                arr = [arr];
            }
        }
        else if (arr && isObj(arr) && isFunc(arr.toJSON)) {

            arr = arr.toJSON();
        }

        if (arr) {

            $.each(arr, function (i, s) {

                if (cafm.util.hasStringVal(s)) {

                    arr[i] = '<li>' + s + '</li>';
                }
            });
            arr.unshift('<ul>');
            arr.push('</ul>');
            return arr.join('');
        }
        return arr;
    }

    /**
     * Ensures all the objects fields as specified in the fields array are instantiated as JavaScript Dates, applies to date properties that have been serialised into a string.
     * @param {Array} objects The array of objects containing the fields to manipulate
     * @param {Array} fields The field names of the properties to turn into JavaScript Dates
     * @return {Array} Returns the modified array of objects
     */
    static ensureAllDates(objects, fields) {

        if (!objects) {
            return;
        }
        objects.forEach(function (o) {
            cafm.util.ensureDates(o, fields);
        });
        return objects;
    }

    static convertAllUTCToSessionDateTimes(objects, fields) {
        if (!objects) {
            return;
        }

        if (isArray(objects)) {
            objects.forEach(function (o) {
                o = cafm.util.convertUTCToSessionDateTimes(o, fields);
            });    
        } else {
            objects = cafm.util.convertUTCToSessionDateTimes(objects, fields);
        }
        return objects;
    }

    static convertUTCToSessionDateTimes(o, fields) {
        fields.forEach(function (n) {
            o[n] = cafm.web.funcs.fromUTCToSessionDateTime(o[n]);
        });
        return o;
    }

    /**
     * Ensures the object fields as specified in the fields array are instantiated as JavaScript Dates, applies to date properties that have been serialised into a string
     * @param {Object} o The object containing the fields to manipulate
     * @param {Array} fields The field names of the properties to turn into JavaScript Dates
     * @return {Object} Returns the modified object
     */
    static ensureDates(o, fields) {
            fields.forEach(function (n) {
                o[n] = cafm.util.ensureDate(o[n]);
            });
        return o;
    }

    /**
     * Ensures a value is returned as a JavaScript Date if it is a string, otherwise just returns the value as is
     * @param {String} v The string date value
     * @return {Date} Returns a JavaScript Date object
     */
    static ensureDate(v, changeForm) {

        if (v && isStr(v)) {

            // handle ms format date strings
            if (v.indexOf('/') == 0) {

                return new Date(parseInt(v.substr(6)));
            }
            // handle iso date string
            else {

                if (cafm.util.dateStringIsMin(v)) {
                    return null;
                }

                if (v == null || v == '(not set)') {
                    return v = "(not set)";
                }

                try {
                    // construct date from string
                    var d = moment(v,"YYYY-MM-DDTHH:mm");                                
                    return d.toDate();
                }
                catch (err) {
                    alert('Date construction failed with string. Please report this error.');
                }
            }
        }
        return v;
    }

    /**
     * Converts a JS Date or string to an ISO format date string
     * @param {(Date|String)} d The JS Date or string
     * @return {String} Returns an ISO format date string
     */
    static toIsoDateString(d) {

        if (!d) return '';

        if (isStr(d)) {

            d = cafm.util.ensureDate(d);
        }

        let y = d.getFullYear();
        let m = d.getMonth() + 1;
        let da = d.getDate();
        let h = d.getHours();
        let mi = d.getMinutes();
        let s = d.getSeconds();

        if (m < 10) {
            m = '0' + m;
        }
        if (da < 10) {
            da = '0' + da;
        }
        if (h < 10) {
            h = '0' + h;
        }
        if (mi < 10) {
            mi = '0' + mi;
        }
        if (s < 10) {
            s = '0' + s;
        }

        return [y, '-', m, '-', da, 'T', h, ':', mi, ':', s, 'Z'].join('');
    }

    /**
     * Determines if a string represents the minimum date value
     * @param {String} s The string date value
     * @return {Boolean} Returns true if the date string is equal to a minimum value date
     */
    static dateStringIsMin(s) {

        return isStr(s) && (s.indexOf('0001-01-01T00:00') == 0 || s.indexOf('1901-06-01T00:00:00') == 0);
    }

    /**
     * Changes a JS Date or string to UTC equivalent
     * @param {(Date|String)} dateValue The JS Date or string
     * @return {Date} Returns UTC date
     */
    static toUtcDate(dateValue) {

        if (!isDate(dateValue)){

            var d = new Date();
            dateValue = cafm.util.ensureDate(d.toISOString());
        }

        if (!dateValue) {

            return dateValue;
        }

        let utlMillis = Date.UTC(dateValue.getFullYear(), dateValue.getMonth(), dateValue.getDate(), dateValue.getHours(), dateValue.getMinutes(), dateValue.getSeconds(), dateValue.getMilliseconds());
        return new Date(utlMillis);
    }

    /**
     * Changes all properties that are JS dates to UTC equivalent
     * @param {Object} obj The object to convert member dates
     * @return {Object} Returns the input object with UTC dates
     */
    static allDatesToUtc(obj) {

        for (let key in obj) {

            let o = obj[key];

            if (isDate(o)) {

                obj[key] = cafm.util.toUtcDate(o);
            }
            else if (isArray(o)) {

                cafm.util.allDatesToUtc(o);
            }
            else if (isObj(o)) {

                cafm.util.allDatesToUtc(o);
            }
        }

        return obj;
    }

    /**
     * Get the current time in milliseconds
     * @return {Number} Returns time in milliseconds
     */
    static getTime() {

        return (new Date).getTime();
    }

    /**
     * Get a time span object for a number of milliseconds
     * @param {Number} m The number of milliseconds
     * @return {{ years: Number, months: Number, days: Number, hours: Number, minutes: Number, seconds: Number, milliseconds: Number }} Returns a time span object
     */
    static getTimeSpanFromMilliseconds(m, options) {

        let msPerSecond = 1000;
        let msPerMinute = msPerSecond * 60;
        let msPerHour = msPerMinute * 60;
        let msPerDay = msPerHour * 24;
        let msPerMonth = msPerDay * 30;
        let msPerYear = msPerDay * 365;
        let ts = {};
        if (!options) options = {};

        if (m >= msPerYear && !options.excludeYears) {

            ts.years = Math.floor(m / msPerYear);
            m = m % msPerYear;
        }
        if (m >= msPerMonth && !options.excludeMonths) {

            ts.months = Math.floor(m / msPerMonth);
            m = m % msPerMonth;
        }
        if (m >= msPerDay && !options.excludeDays) {

            ts.days = Math.floor(m / msPerDay);
            m = m % msPerDay;
        }
        if (m >= msPerHour) {

            ts.hours = Math.floor(m / msPerHour);
            m = m % msPerHour;
        }
        if (m >= msPerMinute) {

            ts.minutes = Math.floor(m / msPerMinute);
            m = m % msPerMinute;
        }
        if (m >= msPerSecond) {

            ts.seconds = Math.floor(m / msPerSecond);
            m = m % msPerSecond;
        }
        if (m > 0) {

            ts.milliseconds = m;
        }

        return ts;
    }

    /**
     * Converts a time span object to a string
     * @param {Object} e The time span object
     * @return {String} Returns the time span as a string
     */
    static timeSpanToString(e) {

        let ts = e.timeSpan;
        let str = [];

        if (e.years && ts.years) {

            str.push([ts.years, ts.years > 1 ? cafm.res.str.LabelYears : cafm.res.str.LabelYear].join(' '));
        }
        if (e.months && ts.months) {

            str.push([ts.months, ts.months > 1 ? cafm.res.str.LabelMonths : cafm.res.str.LabelMonth].join(' '));
        }
        if (e.days && ts.days) {

            str.push([ts.days, ts.days > 1 ? cafm.res.str.LabelDays : cafm.res.str.LabelDay].join(' '));
        }
        if (e.hours && ts.hours) {

            str.push([ts.hours, ts.hours > 1 ? cafm.res.str.LabelHours : cafm.res.str.LabelHour].join(' '));
        }
        if (e.minutes && ts.minutes) {

            str.push([ts.minutes, ts.minutes > 1 ? cafm.res.str.LabelMinutes : cafm.res.str.LabelMinute].join(' '));
        }
        if (e.seconds && ts.seconds) {

            str.push([ts.seconds, ts.seconds > 1 ? cafm.res.str.LabelSeconds : cafm.res.str.LabelSecond].join(' '));
        }
        if (e.milliseconds && ts.milliseconds) {

            str.push([ts.milliseconds, ts.milliseconds > 1 ? cafm.res.str.LabelMilliseconds : cafm.res.str.LabelMillisecond].join(' '));
        }

        return str.join(e.separator);
    }

    /**
     * Truncate a JS Date or string to the Date at the time 00:00:00
     * @param {(Date|String)} d The JS Date or string
     * @return {Date} Returns the truncated Date
     */
    static truncateToDate(d) {

        if (isNullOrUndefined(d)) {

            return d;
        }
        else if (!isDate(d)) {

            d = cafm.util.ensureDate(d);
        }

        d.setHours(0, 0, 0, 0);
        return d;
    }

    /**
     * Truncate a JS Date or string to minutes e.g. 12:10:00
     * @param {(Date|String)} d The JS Date or string
     * @return {Date} Returns the truncated Date
     */
    static truncateToMinutes(d) {

        if (isNullOrUndefined(d)) {

            return d;
        }
        else if (!isDate(d)) {

            d = cafm.util.ensureDate(d);
        }

        d.setSeconds(0, 0);
        return d;
    }

    /**
     * Get the current time truncated to minutes
     * @return {Date} Returns the current time as a Date truncated to minutes
     */
    static nowTruncateToMinutes() {

        return Util.truncateToMinutes(new Date());
    }

    /**
     * Get the current time truncated to days
     * @return {Date} Returns the current time as a Date truncated to days
     */
    static nowTruncateToDate() {

        let d = new Date();
        d.setHours(0, 0, 0, 0);
        return d;
    }

    /**
     * Test if two dates are the same
     * @param {Date} d1 The first date to test
     * @param {Date} d2 The second date to test
     * @return {Boolean} Returns true if the two dates are for the same day
     */
    static datesAreSame(d1, d2) {
        if (isStr(d1) && isStr(d2)) {
            return (d1 === d2);
        }
        return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
    }

    /**
    * Test if two dates are the same date, hour, minute of the day
    * @param {Date} d1 The first date to test
    * @param {Date} d2 The second date to test
    * @return {Boolean} Returns true if the two dates are for the same date, hour, minute of the day
    */
    static dateTimesAreSame(d1, d2) {
        return Util.datesAreSame(d1, d2) && d1.getHours() === d2.getHours() && d1.getMinutes() === d2.getMinutes();
    }
    
    /**
    * Get the hours & minutes difference between two dates
    * @param {Date} d1 The first date to test
    * @param {Date} d2 The second date to test
    * @return {{ hours: number, minutes: number }} Returns an object containing hours and minutes properties
    */
    static datesHoursMinsDiff(d1, d2) {

        let s = cafm.util.ensureDate(d1); // start
        let e = cafm.util.ensureDate(d2); // end

        let h;
        let m;

        if (isDate(s) && isDate(e)) {

            let diff = e.getTime() - s.getTime();

            if (diff > 0) {

                h = parseInt(diff / 3600000);
                m = (diff % 3600000) / 60000;
            }
        }

        return {

            hours: h ? h : 0,
            minutes: m ? m : 0
        };
    }

    /**
    * Get the minutes difference between two dates
    * @param {Date} d1 The first date to test
    * @param {Date} d2 The second date to test
    * @return {number} Returns minutes difference between the two dates
    */
    static datesMinsDiff(d1, d2) {

        let s = cafm.util.ensureDate(d1), // start
            e = cafm.util.ensureDate(d2), // end
            m;

        if (isDate(s) && isDate(e)) {

            let diff = e.getTime() - s.getTime();

            if (diff > 0) {

                m = parseInt(diff / 60000);
            }
        }

        return m ? m : 0;
    }

   /**
    * Add days to a date
    * @param {Date} d The date to add the days to
    * @param {number} days The number of days to add
    * @return {Date} Returns the modified date
    */
    static addDays(d, days) {

        return new Date(d.getTime() + (86400000 * days));
    }

    /**
    * Add minutes to a date
    * @param {Date} d The date to add the minutes to
    * @param {number} m The number of minutes to add
    * @return {Date} Returns the modified date
    */
    static addMinutes(d, m) {

        return new Date(d.getTime() + (60000 * m));
    }

    /**
    * Subtract minutes from a date
    * @param {Date} d The date to subtract the minutes from
    * @param {number} m The number of minutes to substract
    * @return {Date} Returns the modified date
    */
    static subMinutes(d, m) {

        return new Date(d.getTime() - (60000 * m));
    }

    /**
    * Converts a string to an array with a default splitter of ; . If the string doesn't contain the splitter then an array with a length of 1 will be returned.
    * @param {String} v The string value
    * @param {String} s The string splitter (optional - default is ;)
    * @return {Array} Returns an Array
    */
    static stringToArray(v, s) {

        if (!s) s = ';';
        if (v.indexOf(';') > -1) {
            v = v.split(';');
        }
        else
            v = [v];
        return v;
    }

    /**
    * Converts a string to an array with a default splitter of ; . If the string doesn't contain the splitter then an array with a length of 1 will be returned.
    * @param {String} parentId The string value
    * @param {String} childId The string splitter (optional - default is ;)
    * @return {{ ParentID: { ID: String }, ChildID: {  ID: String } }} Returns the parent child DTO
    */
    static createParentChildId(parentId, childId) {

        return {
            ParentID: { ID: parentId },
            ChildID: { ID: childId }
        };
    }

    /**
    * Creates an ID DTO
    * @param {String} id The ID to encapsulate
    * @return {{ ID: String }} Returns an ID DTO
    */
    static idData(id) {

        return {
            ID: id
        };
    }

    /**
    * Sets Hours/Minutes to end of day on a Date object by ref
    */
    static moveToEndOfDay(d) {
        if (isDate(d)) {
            d.setHours(23);
            d.setMinutes(59);
            d.setSeconds(59);
        }
        return d;
    }

    /**
    * Reduces a string from the first space following after the specified start index with an optional appendage
    * @param {String} s The string to reduce
    * @param {Number} start The start index to start looking for a space to chop from
    * @param {String} append The characters to append (optional)
    * @return {String} Returns the reduced string
    */
    static reduceString(s, start, append) {

        if (!s || s.length - 1 < start) {
            return s;
        }
        let ret = s.slice(0, start);
        let ns = s.slice(start);
        let upTo = ns.indexOf(' ');
        if (upTo >= 0 && upTo < 15)
            ret += ns.slice(0, upTo);
        if (append) ret += append;
        return ret;
    }

    /**
    * Converts encoded or unencoded line breaks
    * @param {String} s The string to convert
    * @return {String} Returns a string with line breaks converted
    */
    static convertLineBreaks(s) {

        if (!s) return s;

        // check for encoding
        if (s.indexOf('\r') > -1 || s.indexOf('\n') > -1) {

            s = s.replace(/\r\n/g, '<br/>');
            s = s.replace(/\r/g, '<br/>');
            s = s.replace(/\n/g, '<br/>');
        }
        else {

            s = s.replace(/&#13;&#10;/g, '<br/>');
            s = s.replace(/&#13;/g, '<br/>');
            s = s.replace(/&#10;/g, '<br/>');
        }

        return s;
    }

    /**
    * HTML decodes a string
    * @param {String} s The string to decode
    * @return {String} Returns the decoded string
    */
    static decodeHtml(s) {

        // check input
        if (!s || !isStr(s)) return s;

        Util.hiddenPreElement.innerHTML = s.replace(/</g, "&lt;");

        return Util.hiddenPreElement.textContent;
    }

    /**
    * HTML encodes a string
    * @param {String} s The string to encode
    * @return {String} Returns the encoded string
    */
    static encodeHtml(s) { 

        // check input
        if (!s || !isStr(s)) return s;

        return s.
            replace(/&/g, '&amp;').
            replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, function (v) {
                let hi = v.charCodeAt(0);
                let low = v.charCodeAt(1);
                return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
            }).
            replace(/([^\#-~| |!])/g, function (v) {
                return '&#' + v.charCodeAt(0) + ';';
            }).
            replace(/</g, '&lt;').
            replace(/>/g, '&gt;');
    }

    /**
    * Encodes a string and template escapes # with \\#
    * @param {String} s The string to encode and template escape
    * @return {String} The template escaped encoded string
    */
    static toSafeTemplateLabel(s) {

        if (!s) return s;

        if (s.indexOf('#') > -1) {

            s = s.replace(/#/g, '\\#')
        }

        s = Util.encodeHtml(s);

        return s;
    }

    /**
    * Encodes a HTML string and replaces line breaks with <br/>
    * @param {String} s The string to encode and format
    * @param {String} d Optional default string if passed string is empty
    * @param {Boolean} t Option to trim string (optional - defailt is false)
    * @param {Boolean} p Prevent line break conversion (optional - defailt is true)
    * @return {String} Returns the encoded formatted HTML string
    */
    static toSafeHtml(s, d, t, p) {

        // check input - return default or empty string otherwise
        if (!Util.hasStringVal(s)) return d ? Util.encodeHtml(d) : '';

        // trim if flagged to do so
        if (t) s = s.trim();

        s = Util.encodeHtml(s);

        // convert line breaks if not flagged to not do so
        if (p !== true) s = Util.convertLineBreaks(s);

        return s;
    }

    /**
    * Gets the caret position of the textbox or textarea
    * @param {(HTMLTextAreaElement|HTMLInputElement)} el The HTML text input or TextArea
    * @return {Number} The caret position starting from 1
    */
    static getCaretPosition(el) {

        if (el.selectionStart) {
            return el.selectionStart;
        } else if (document.selection) {
            el.focus();

            let r = document.selection.createRange();
            if (r == null) {
                return 0;
            }

            let re = el.createTextRange(),
                rc = re.duplicate();
            re.moveToBookmark(r.getBookmark());
            rc.setEndPoint('EndToStart', re);

            return rc.text.length;
        }
        return 0;
    }

    /**
    * Sets the caret position within a textbox or textarea
    * @param {HTMLTextAreaElement|HTMLInputElement} el The HTMLInputElement or HTMLTextAreaElement
    * @param {Number} caretPos The caret position to set - starting from 1
    */
    static setCaretPosition(el, caretPos) {

        let elem = el[0];
        if (elem != null) {
            if (elem.createTextRange) {
                let range = elem.createTextRange();
                range.move('character', caretPos);
                range.select();
            }
            else {
                if (elem.selectionStart) {
                    elem.focus();
                    elem.setSelectionRange(caretPos, caretPos);
                }
                else
                    elem.focus();
            }
        }
    }

    /**
    * Clone an object
    * @param {Object} obj The object to clone
    * @param {Boolean} deep >Do deep clone?
    * @return {Object} Returns the cloned object
    */
    static clone(obj, deep) {

        if (!obj) return null;

        // if this is a kendo object then convert to POJO
        if (isFunc(obj.toJSON)) obj = obj.toJSON();

        // delete the uid if there is one
        if (obj.uid) delete obj.uid;

        // use jquery to "clone" object - be aware child objects are not recreated - object references are kept
        let clone = deep === true ? $.extend(deep, {}, obj) : $.extend({}, obj);

        // find all dates and actually create a new instance for each one
        for (let p in clone) {

            if (isDate(clone[p])) {

                clone[p] = new Date(clone[p].valueOf());
            }
        }

        return clone;
    }

    /**
    * Performs a download request (not ajax)
    * @param {String} url The target URL
    * @param {String} data >The string data to send
    * @param {String} method >The HTTP method (defaults to POST)
    */
    static download(url, data, method) {

        // url and data options required
        if (url && data) {
            // data should be stringified json
            if (data.indexOf('+') > -1) {
                data = data.replace(/\+/g, cafm.res.consts.PostParam_PlusReplacement);
            }
            let inputs = '<input type="hidden" name="StringData" value="' + escape(data) + '" />';
            // send request
            $('<form action="' + url + '" method="' + (method || 'post') + '">' + inputs + '</form>')
                .appendTo(body).submit().remove();
        }
    }

    /**
    * Call a function and pass arguments
    * @param {(String|Function)} nameOrFunc The function or string reference path to the function
    * @param {Object} arg Optional function arument 1
    * @param {Object} arg2 Optional function arument 2
    * @param {Boolean} cache Cache the function as a handler, using nameOrFunc String as the key
    * @return {Object} The returned contents of the function
    */
    static callFunction(nameOrFunc, arg, arg2, cache) {

        if (!nameOrFunc) {

            return null;
        }

        let func = isFunc(nameOrFunc) ? nameOrFunc : cafm.util.getReference(nameOrFunc);

        if (isFunc(func)) {

            if (cache && isStr(nameOrFunc)) {
                cafm.handlers.set(nameOrFunc, func);
            }
            return func(arg, arg2);
        }
        else {

            return null;
        }
    }

    /**
    * Call a function using setTimeout and pass arguments
    * @param {(string|function|{ func: function, arg1: object, arg2: object, arg3: object, arg4: object, arg5: object, timeout: number })} args The function or string reference path to the function, or an args object
    * @param {object} arg Optional function arument 1
    * @param {object} arg2 Optional function arument 2
    * @param {bool} cache Cache the function as a handler, using nameOrFunc String as the key
    * @return {object} Returns the returned contents of the function
    */
    static callFunctionAsync(args, arg, arg2, cache) {
        
        if (isStr(args) || isFunc(args)) {

            return setTimeout(() => {

                cafm.util.callFunction(args, arg, arg2, cache)
            }, 1);
        }
        else {

            if (args.key && !cafm.util.timeouts) cafm.util.timeouts = {}
            if (args.key && cafm.util.timeouts[args.key]) return;

            let tref = setTimeout(() => {

                try {

                    cafm.util.callFunction(args.func, args.arg1, args.arg2, args.arg3, args.arg4, args.arg5)
                }
                finally {

                    // remove the timeout from array - so the func with key can be called again
                    if (cafm.util.timeouts) delete cafm.util.timeouts[args.key];
                }

            }, args.timeout ? args.timeout : 1);

            if (args.key) cafm.util.timeouts[args.key] = tref;

            return tref;
        }
    }

    /**
    * Get a reference to an object or function by name
    * @param {string} name The reference path to the target
    * @param {object} obj Optional object to search, default is window
    * @return {object} Returns the object reference
    */
    static getReference(name, obj) {

        if (!name) return null;

        let ref;
        if (!name.indexOf('.') > -1) {

            try {

                let items = name.split('.'), inScope;
                for (let i = 0; i < items.length; i++) {

                    if (i > 0 && !inScope) break;

                    let item = items[i];

                    if (!inScope) {

                        inScope = !obj ? window[item] : obj[item];
                    }
                    else {

                        inScope = inScope[item];
                    }
                }
                ref = inScope;
            }
            catch (err) { }

        }
        else {

            ref = window[name]
        }

        return ref;
    }

    /**
    * Method to get a value with a property name that is not case sensitive
    * @param {object} obj The object to get the property value from
    * @param {string} propertyName The property name
    * @return {object} Returns the property value
    */
    static getProperty(obj, propertyName) {

        if (!Util.hasStringVal(propertyName)) return null;

        propertyName = propertyName.toLowerCase();

        for (let p in obj) {

            if (obj.hasOwnProperty(p) && propertyName == p.toLowerCase()) {

                return obj[p];
            }
        }
    }

    /**
    * Method to set a propety value with a property name that is case sensitive
    * @param {object} obj The object to set the property value on
    * @param {string} path The property name/path
    * @param {object} value The property value
    */
    static setProperty(obj, path, value) {

        if (path.indexOf('.') > -1) {

            let ref;
            try {

                let lastIndex = path.lastIndexOf('.');
                let parentName = path.substring(0, lastIndex);
                let name = path.substring(lastIndex + 1);
                let items = parentName.split('.');
                let inScope;
                items.forEach(function (item) {
                    if (!inScope) {
                        inScope = !obj ? window[item] : obj[item];
                    }
                    else {
                        inScope = inScope[item];
                    }
                });
                ref = inScope;
                ref[name] = value;
            }
            catch (err) { }
        }
        else {

            obj[path] = value;
        }
    }

    /**
    * Determine if a value is true (checks bool and string)
    * @param {(string|bool)} v The bool or string to test
    * @return {bool} Returns true if the bool=true or the string='true'|'True'
    */
    static isTrue(v) {

        return (isBool(v) && v) || (isStr(v) && v.toLowerCase() == 'true');
    }

    /**
    * Converts jQuery element text or simply text to a boolean yes/no string
    * @param {(string|JQuery)} e The jQuery element or string
    * @return {string} Returns a yes/no string
    */
    static toYesNoString(e) {

        if (isJQuery(e)) {
            e = e.text();
        }
        return Util.isTrue(e) ? cafm.res.str.TextYes : cafm.res.str.TextNo;
    }

    /**
    * Converts jQuery element text or simply text to currency formatted number string
    * @param {(string|JQuery)} e The jQuery element or string
    * @return {string} Returns a formatted currency string
    */
    static toFormattedCurrency(e) {

        let def = e.data('default');
        if (isJQuery(e)) {
            e = e.text();
        }
        if (def && e == def) {
            return def;
        }
        if (isStr(e) && Util.isNum(e)) {

            e = parseFloat(e);
        }

        if (e) {

            return kendo.toString(e, 'c');
        }
        else if (def) {

            return def;
        }
        else {

            return '';
        }
    }

    /**
    * Converts jQuery element text or simply text to currency formatted number string 
    * @param {(string|JQuery)} e The jQuery element or string
    * @return {string} Returns a formatted currency with string and currency symbol
    */
    static toFormattedCurrencySymbol(e) {

        if (isJQuery(e)) {
            e = e.text();         
        }
        var currencySymbol = Util.getCurrencySymbolByPath()
        if (e) {
            return kendo.toFormatNumber(e, 'c', currencySymbol);
        }
        else {
            return '';
        }
    }

    static getCurrencySymbolByPath() {
        var pathName = window.location.pathname;
        var currencySymbol = '';

        if (pathName === '/helpdesk' && !isNullOrUndefined(cafm.hd.workOrder)) {
            currencySymbol = cafm.hd.workOrder.get('CurrencySymbol');
        }
        if (pathName === '/roombooking') {

            if (!isNullOrUndefined(cafm.rb.form)) {
                var roomBooking = cafm.rb.form.getRoomBooking();
                currencySymbol = roomBooking.CurrencySymbol;
            }
        }

        if (pathName === '/stockmanagement') {

            if (!isNullOrUndefined(cafm.stockmgt)) {
                currencySymbol = cafm.stockmgt.getCurrencySymbolForCurrentBalance();
            }
        }
        return currencySymbol;
    }

    /**
    * Converts jQuery element text or simply text to a percentage formatted number string
    * @param {(string|JQuery)} e The jQuery element or string
    * @return {string} Returns a percentage formatted number string
    */
    static toFormattedPercentage(e) {

        let def = e.data('default');
        if (isJQuery(e)) {
            e = e.text();
        }
        if (def && e == def) {
            return def;
        }
        if (isStr(e) && Util.isNum(e)) {

            e = parseFloat(e);
        }

        if (!isNullOrUndefined(e)) {

            return kendo.toString(e, cafm.res.consts.Format_Percentage);
        }
        else if (def) {

            return def;
        }
        else {

            return '';
        }
    }

    /**
    * Converts jQuery element text or simply text to jQuery <a> element
    * @param {(string|JQuery)} e The jQuery element or string containing the URL
    * @return {JQuery} Returns a jQuery <a> element
    */
    static toHyperlink(e) {

        let txt;
        let link;
        if (isJQuery(e)) {
            link = e.text();
            txt = e.data('text');
        }
        else {
            link = e.link;
            txt = e.text;
        }
        if (link && txt) {
            return $('<a />', {
                href: link,
                text: txt,
                target: !cafm.url.isLocal(link) ? '_blank' : null
            });
        }
        else {
            return '';
        }
    }

    /**
    * Converts jQuery element text or simply text to a formatted date
    * @param {(string|JQuery)} e The jQuery element or string containing the date
    * @return {JQuery} Returns a formatted date string
    */
    static toFormattedDate(e) {

        let isJq = isJQuery(e);
        let def = isJq ? e.data('default') : '';

        if (isJq) {
            e = e.text();
        }
        if (def && e == def) {
            return def;
        }
        if (isStr(e)) {

            e = cafm.util.ensureDate(e);
        }

        if (e) {

            return kendo.toString(e, 'd');
        }
        else if (def) {

            return def;
        }
        else {

            return '';
        }
    }

    /**
    * Converts jQuery element text or simply text to a formatted date time
    * @param {(string|JQuery)} e The jQuery element or string containing the date time
    * @return {JQuery} Returns a formatted date time string
    */
    static toFormattedDateTime(e) {

        let isJq = isJQuery(e);
        let def = isJq ? e.data('default') : '';

        if (isJq) {

            // check if there is a bound vm value, if so retrieve it
            let boundValue = e.getDataBoundValue();
            if (boundValue) {

                e = boundValue;
            }
            else if (isJQuery(e) || isNullOrUndefined(e)) {

                e = e.text();
            }
        }
        if (def && e == def) {
            return def;
        }



        if (e) {
            e = cafm.util.toDateString(e, 'g', '');
            return e;
        } else if (def) {
            return def;
        }
        else {
            return '';
        }
    }

    /**
    * Converts jQuery element text or simply text to a formatted time
    * @param {(string|JQuery)} e The jQuery element or string containing the time
    * @return {JQuery} Returns a formatted time string
    */
    static toFormattedTime(e) {

        let isJq = isJQuery(e);
        let def = isJq ? e.data('default') : '';

        if (isJq) {

            // check if there is a bound vm value, if so retrieve it
            let boundValue = e.getDataBoundValue();
            if (boundValue) {

                e = boundValue;
            }
            else if (isJQuery(e) || isNullOrUndefined(e)) {

                e = e.text();
            }
        }
        if (def && e == def) {
            return def;
        }
        if (isStr(e)) {

            e = cafm.util.ensureDate(e);
        }

        if (e) {

            return kendo.toString(e, 't');
        }
        else if (def) {

            return def;
        }
        else {

            return '';
        }
    }

    /**
    * Converts jQuery element text or simply text to a formatted area
    * @param {(string|JQuery)} e The jQuery element or string containing the area
    * @return {JQuery} Returns a formatted area string
    */
    static toFormattedArea(e) {

        if (isJQuery(e)) {
            e = e.text();
        }
        return '{0} {1}'.format(e, cafm.user.prefs.AreaMaskOuputFormat);
    }

    /**
    * Converts jQuery element text or simply text to a formatted long text
    * @param {(string|JQuery)} e The jQuery element or string containing the long text
    * @return {JQuery} Returns a formatted long HTML text
    */
    static toFormattedLongText(e) {

        let def;
        if (isJQuery(e)) {
            def = e.data('default');
            e = e.text();
        }
        return Util.toSafeHtml(e, def, true);
    }

    /**
    * Ensures jQuery element text or simply text has a value
    * @param {(string|JQuery)} e The jQuery element or string containing the value
    * @return {JQuery} Returns the ensured value
    */
    static ensureValueOrDefault(e) {

        let d = e.data('default');
        if (isJQuery(e)) {
            e = e.text();
        }
        if (d && e == d) {

            return d;
        }
        else if (e) {

            return e;
        }
        else if (d) {

            return d;
        }
        else {

            return '';
        }
    }

    /**
     * Ensures a value, returning default if necessary
     * @param {object} v The value
     * @param {object} d The default value
     * @return {object} Returns the ensured value
     */
    static ensureValue(v, d) {

        if (!v) {
            v = d;
        }
        return v;
    }

    /**
    * Converts jQuery element text or simply text to an encoded email
    * @param {(string|JQuery)} e The jQuery element or string containing the email
    * @return {string} Returns an encoded email address
    */
    static toMailTo(email) {

        if (isJQuery(email)) {

            email = email.text();
        }

        return '<a href="{0}">{1}</a>'.format(cafm.util.toMailToLink(email), email);
    }

    /**
    * Converts jQuery element text or simply text to a mailto href attribute value
    * @param {string} email The email
    * @return {string} Returns an email mailto href attribute value
    */
    static toMailToLink(email) {

        if (cafm.util.isValidEmail(email)) {

            return 'mailto:{0}'.format(email);
        }
        else {

            return null;
        }
    }

    /**
    * Open a mailto URL based on object input
    * @param {{ ToAddress: string, Subject: string, MessageBody: string}} o The object tinput
    */
    static mailTo(o) {

        let str = ['mailto:'];

        if (o.ToAddress) {
            str.push(o.ToAddress);
        }
        else {
            // If the supplied address was blank turn it into a non-empty string to avoid ending up with the subject in the email's address field.
            o.ToAddress = '@';
        }
        if (o.Subject) {
            if (o.ToAddress) {
                str.push('&');
            }
            str.push('subject=');
            str.push(o.Subject);
        }
        if (o.MessageBody) {
            if (o.ToAddress || o.Subject) {
                str.push('&');
            }
            str.push('body=');
            str.push(o.MessageBody);
        }

        let mailtoUrl = str.join('');
        window.location = encodeURI(mailtoUrl);
    }

    /**
    * Determines if an email string is a valid email address
    * @param {string} emailString The email
    * @return {bool} Returns true if the email is valid
    */
    static isValidEmail(emailString) {

        return new RegExp(/^\S+@\S+[\.][0-9a-z]+$/).test(emailString);
    }

    /**
    * Converts jQuery element text or simply text to an encoded telephone <a> tag HTML
    * @param {(string|JQuery)} e The jQuery element or string containing the telephone
    * @return {JQuery} Returns an encoded telephone <a> tag HTML string
    */
    static toTel(tel) {

        if (isJQuery(tel)) {

            tel = tel.text();
        }

        if (tel) {

            tel = cafm.util.encodeHtml(tel);
            return '<a href="{0}">{1}</a>'.format(cafm.util.toTelLink(tel), tel);
        }
        else {

            return '';
        }
    }

    /**
    * Converts jQuery element text or simply text to a formatted mailto email <a> jQuery element
    * @param {(string|JQuery)} e The jQuery element or string containing the email
    * @return {JQuery} Returns an email <a> jQuery element
    */
    static toTelLink(tel) {

        let link = tel;
        if (cafm.util.hasStringVal(link)) {

            link = link.toLowerCase();

            if (link.indexOf(' ') > -1) {

                link = link.replace(/ /g, '');
            }

            let ind = link.indexOf('ext:');

            if (ind == 0) {

                link = link.replace('ext:', '');
            }
            else if (ind > 0) {

                link = link.substring(0, ind);
            }
        }

        return link ? 'tel:{0}'.format(link) : '';
    }


    /**
   * Converts a JS Date or string to a formatted Date string without changing Time Zone
   * @param {(Date|string)} v The Date or string 
   * @param {string} f The format string
   * @param {string} d An optional default string
   * @return {string} Returns a date formatted string
   */
    static toDateStringKeepKind(v, f, d) {
        var date = v != null ? kendo.toString(v, f) : (d ? d : '');
        if (isStr(date)) {
            date = Util.ensureDate(date);
        }
        return kendo.toString(date, f);
    }


    /**
    * Converts a UTC JS Date or string to a formatted Date string in Session Time Zone
    * @param {(Date|string)} v The Date or string 
    * @param {string} f The format string
    * @param {string} d An optional default string
    * @return {string} Returns a date formatted string
    */
    static toDateString(v, f, d) {
        if (v===null) {
            if (d!=null) return d;
            return null;
        }

        if (isStr(v)) {
            if (cafm.util.dateStringIsMin(v)) {
                if (d != null) return d;
                return null;
            }
        }

        var date = cafm.web.funcs.fromUTCToSessionDateTime(v);
        return kendo.toString(date, f);
    }


    /**
    * Position toolbar buttons for an action form window
    * @param {{ container: JQuery }} e The args object with a container property for the window content element
    * @return {string} Returns a date formatted string
    */
    static positionWindowButtons(e) {

        if (cafm.util.isTrue(e.container.data('inactive'))) {

            return;
        }

        let winElement = e.container.parents('.k-window:first');
        let winContent = $('.k-window-content', winElement);

        function positionWindowButtonsWorker() {

            if (!winElement.length) {

                let ap = e.container.closest('.mobileActionPanel')

                if (ap.length) {
                    e.container.detach().appendTo(ap);
                }
            }
            else {

                let containerHeight = e.container.outerHeight(true);
                let winContentHeight = winElement.height();
                winContentHeight -= containerHeight;
                winContent.height(winContentHeight);
                e.container.detach().appendTo(winElement);
                e.container.show();

                let winTop = winElement.offset().top;
                winTop -= containerHeight;

                let win = winContent.data('kendoWindow');

                if (win) {

                    win.center();

                    win.bind('close', function () {
                        $(window).off('resize.winButtons', positionWindowButtonsWorker);
                    });
                }
            }
        }

        $(window).on('resize.winButtons', positionWindowButtonsWorker);
        positionWindowButtonsWorker();
    }

    static yesNoDialogue(e) {

        let win;

        let ynCont = $('<div />', {
            'class': 'dlgContainer'
        });

        let msg;
        if (e.message) {

            msg = $('<div />', {
                'class': 'msgPnl',
                'css': {
                    'display': 'none'
                }
            });

            ynCont.append(msg);
        }

        let ynButtons = $('<menu />', {
            'class': 'dlgButtons cTb'
        });

        ynButtons.append($('<button/>', {

            'class': 'btn',
            'data-key': 'Yes',
            'text': cafm.res.str.TextYes,
            'click': function () {

                if (isFunc(e.yesHandler())) {

                    e.yesHandler();
                }
                win.close();
            }

        }))
            .append('<span class="button-spacer"></span>')
            .append($('<button/>', {

                'class': 'btn',
                'data-key': 'No',
                'text': cafm.res.str.TextNo,
                'click': function () {

                    if (isFunc(e.noHandler)) {

                        e.noHandler();
                    }
                    win.close();
                }
            }));

        ynCont.append(ynButtons).appendTo(body);

        let winOpts = {
            draggable: false,
            resizable: false,
            actions: {},
            modal: true,
            title: e.title
        };

        win = ynCont.kendoWindow(winOpts).data('kendoWindow');

        if (e.message) {

            msg.showMessage({

                Title: e.message,
                Type: e.messageType
            });
        }

        win.center();

        if (!e.title) {

            win.wrapper.find('.k-header').remove();
            let top = parseInt(win.wrapper.css('top').replace('px', '')),
                diff = parseInt(win.wrapper.css('padding-top').replace('px', ''));
            win.wrapper.css('top', (top - diff) + 'px');
            win.wrapper.css('padding-top', 0)
        }

        $(window).resize(function () {

            win.center();
        });
    }

    static OKDialogue(e) {

        let win;

        let okCont = $('<div />', {
            'class': 'dlgContainer'
        });

        let msg;
        if (e.message) {

            msg = $('<div />', {
                'class': 'msgPnl',
                'css': {
                    'display': 'none'
                }
            });

            okCont.append(msg);
        }

        let button = $('<menu />', {
            'class': 'dlgButtons cTb'
        });

        button.append($('<button/>', {

            'class': 'btn',
            'data-key': 'OK',
            'text': 'OK',
            'click': function () {

                if (isFunc(e.OKHandler())) {

                    e.OKHandler();
                }
                win.close();
            }

        }))            

        okCont.append(button).appendTo(body);

        let winOpts = {
            draggable: false,
            resizable: false,
            actions: {},
            modal: true,
            title: e.title
        };

        win = okCont.kendoWindow(winOpts).data('kendoWindow');

        if (e.message) {

            msg.showMessage({

                Title: e.message,
                Type: e.messageType
            });
        }

        win.center();

        if (!e.title) {

            win.wrapper.find('.k-header').remove();
            let top = parseInt(win.wrapper.css('top').replace('px', '')),
                diff = parseInt(win.wrapper.css('padding-top').replace('px', ''));
            win.wrapper.css('top', (top - diff) + 'px');
            win.wrapper.css('padding-top', 0)
        }

        $(window).resize(function () {

            win.center();
        });
    }

    static refreshList(e) {

        let lv = e.list ? e.list : $(e.listSelector);

        if (!lv.length) return;

        if (!lv.hasClass('.cLv')) {

            lv = lv.find('.cLv');
        }

        lv.data('onDataSourceRead', function (data) {

            if (e.key) {

                if (isMobile || e.isInPanelBar) {
                    cafm.pb.updateListItemCount(lv, e.key, e.isInPanelBar, true);
                }
                else {
                    cafm.tab.updateListItemCount(lv, e.key, false);
                }
            }

            // check for removable items
            cafm.forms.checkForRemovables();

            if (isFunc(e.callback)) {

                e.callback(data);
            }
        })
        
        lv.refreshListDS();
    }

    static kendoDestroy(el) {

        try {
            kendo.destroy(el);
        }
        catch (err) {
            console.log('kendo destroy caused an error');
        }
    }

    static viewPortWidth(percentage) {

        let win = $(window);
        let width = win.outerWidth(true);

        if (!percentage) {

            return width;
        }
        else {

            return (width / 100) * percentage;
        }
    }

    static viewPortHeight(percentage) {

        let win = $(window);
        let height = win.outerHeight(true);

        if (!percentage) {

            return height;
        }
        else {

            return (height / 100) * percentage;
        }
    }

    static hasEnumValue(value, enumValue) {

        return (value & enumValue) != 0;
    }

    static isNum(val) {

        return val && !isNaN(val);
    }

    static guidHasValue(guidVal) {

        return (guidVal && guidVal != cafm.guid.empty) === true;
    }

    static num(v){

        if (isNum(v)) {

            return v;
        }
        else {

            return 0;
        }
    }

    static trimEnd(url, trimChar) {

        if (url.lastIndexOf(trimChar) == (url.length - 1)) {

            url = url.substr(0, url.length - 1);
        }
        return url;
    }

    static hasItem(array){

        return array && array.length > 0;
    }

    static setMultipleParameterValues(obj, sourceField, targetField) {
        
        if (!obj)
        {
            return;
        }

        if (!targetField) {

            targetField = sourceField;
        }

        let items = cafm.util.getReference(sourceField, obj);
        let targetValues = [];

        if (cafm.util.hasItem(items)) {

            $.each(items, function (i, item) {

                if(item) targetValues.push(item.value);
            });
        }

        // assume kendo if there is a set method
        if (isFunc(obj.set)) {

            obj.set(targetField, targetValues);
        }
        else {

            cafm.util.setProperty(obj, targetField, targetValues);
        }
    }

    static getItemValue(obj) {
        
        if(isObj(obj)) {

            return obj.value;
        }
        else {

            return obj;
        }
    }

    static capitalise(s) {

        let firstChar = s.substr(0, 1);
        let charAscii = firstChar.charCodeAt(0);
        if (charAscii > 96 && charAscii < 123) {

            let newfirstChar = String.fromCharCode(charAscii - 32);
            s = s.replace(firstChar, newfirstChar);
        }
        return s;
    }

    static filterItemsByLocationId(items, lid, showAllWithNoLocation, propertyName) {

        if(isArray(items)) {

            let isCompany = lid === cafm.auth.companyId();

            if (!propertyName) propertyName = 'locationId';

            return cafm.util.where(items, function (item) {

                return !item[propertyName] || item[propertyName] == cafm.guid.empty || item[propertyName] == lid || (isCompany && showAllWithNoLocation);
            });
        }
        else {
            
            return null;
        }
    }

    static formatServerError(json){

        if (isNullOrUndefined(json)) {

            return null;
        }

        if (isStr(json) && cafm.util.hasStringVal(json)) {

            let errorObj = JSON.safeParse(json);
        }

        let errStr = [];

        if (isDefined(errorObj.Message)) {

            errStr.push(errorObj.Message);
        }

        if (isDefined(errorObj.ExceptionType)) {

            errStr.push('<b>Exception type:</b> ' + errorObj.ExceptionType);
        }

        if (isDefined(errorObj.ExceptionMessage)) {

            errStr.push('<b>Exception message:</b> ' + errorObj.ExceptionMessage);
        }

        if (isDefined(errorObj.StackTrace)) {

            errStr.push('<b>Stack trace:</b>\n' + errorObj.StackTrace);
        }

        if (errStr.length) {

            errStr = errStr.join('\n\n');
            return errStr;
        }
        else {

            return null;
        }
    }

    static modifyPager(wrapper, dataSource, options) {

        let cPager = $('.k-pager-wrap', wrapper);
        let t = dataSource.total();

        if (isNullOrUndefined(options)) {

            if (!wrapper.data('options')) {

                options = {};
                wrapper.data('options', options);
            }
            else {

                options = wrapper.data('options');
            }
        }

        if (!dataSource || t <= dataSource.pageSize()) {

            if (t > 0) {

                cPager.addClass('cPager1Page').show();
            }
            else {

                cPager.hide();
            }
        }
        else {

            if (!options.AutoBind && !options.HasPagerBound) {
                $('.k-pager-wrap .k-pager-sizes', wrapper).show();
                $('.k-pager-wrap .k-link, .k-pager-wrap .k-pager-numbers', wrapper).show();
                options.HasPagerBound = true;
            }

            cPager.removeClass('cPager1Page').show();

            if (isMobile) {

                setTimeout(function () {

                    let links = cPager.children('.k-link').not('.k-pager-first,.k-pager-last');
                    links.first().attr('data-role', 'PreviousPage').find('.k-icon').html('&#8249;');
                    links.last().attr('data-role', 'NextPage').find('.k-icon').html('&#8250;');
                }, 250);
            }
        }
    }

    static ensure24HourTime(ts){

        let isPm = ts.indexOf('PM') > -1;

        if (ts.indexOf('AM') > -1 || isPm) {
            
            ts = ts.replace('AM', '');
            ts = ts.replace('PM', '');
            ts = ts.trim();

            let time = ts.split(':');

            if (isPm) {

                if (time[0] != 12) {

                    time[0] = parseInt(time[0]) + 12;
                }
            }
            else if (time[0] == 12) {

                time[0] = '00';
            }

            ts = time.join(':');
        }

        return ts;
    }

    static compareTimeStrings(ts1, ts2) {

        if (isNullOrUndefined(ts1)) {

            return -1;
        }
        if (isNullOrUndefined(ts2)) {

            return 1;
        }

        let t1 = ts1.split(':');
        let t2 = ts2.split(':');
        let ret;

        let t1Hour = parseInt(t1[0]);
        let t1Min = parseInt(t1[1]);
        let t2Hour = parseInt(t2[0]);
        let t2Min = parseInt(t2[1]);

        if (t1Hour > t2Hour) {

            ret = 1;
        }
        else if (t1Hour == t2Hour && t1Min > t2Min) {

            ret = 1;
        }
        else if (t2Hour > t1Hour) {

            ret = -1;
        }
        else if (t2Hour == t1Hour && t2Min > t1Min) {

            ret = -1;
        }
        else {

            ret = 0;
        }

        return ret;
    }

    static syncClientServerObjects(clientObj, serverObj, excludeFieldNames) {
        /// <summary>Syncs a server object with a Kendo object, only setting the values that have changed</summary>
        /// <param name="clientObj" type="kendo.Observable">The kendo client object</param>
        /// <param name="serverObj" type="Object">The other array to compare</param>
        /// <param name="excludeFieldNames" type="Array">Array of string field names to exclude from the sync</param>

        // go through every field on the server object
        for (let fieldName in serverObj) {

            // if uid, internal field, or a function then skip
            if (fieldName == 'uid' || fieldName.startsWith('_') || isFunc(serverObj[fieldName]) || (cafm.util.hasItem(excludeFieldNames) && excludeFieldNames.indexOf(fieldName) > -1)) {

                continue;
            }

            // get reference to client and server fields
            let serverItem = serverObj[fieldName], clientItem = clientObj[fieldName];

            // do null checking as isObj returns true for null
            if (serverItem == null && clientItem != null || clientItem == null && serverItem != null) {

                // the client and server items are different so update the client
                if (clientObj.set) clientObj.set(fieldName, serverItem);
                else clientObj[fieldName] = serverItem;
                continue;
            }

            // check for arrays, for the moment we will always update arrays as a whole
            // if it's an object then recursively call this function with items as arguments
            if (!isDate(serverItem) && !isArray(serverItem) && isObj(serverItem) && serverItem != null) {

                // recursive call
                cafm.util.syncClientServerObjects(clientItem, serverItem);
            }
            else if (serverItem != clientItem) {

                // the client and server items are different so update the client
                clientObj.set(fieldName, serverItem);
            }
        }
    }

    static doWhen(doFunc, whenFunc, maxIteration, timeout, fallback, iteration) {

        if (isUndefined(maxIteration)) maxIteration = 30;
        if (isUndefined(timeout)) timeout = 1000;
        if (isUndefined(iteration)) iteration = 0;
        
        if (whenFunc()) {

            doFunc(iteration);
        }
        else if (iteration < maxIteration) {

            setTimeout(function () {

                cafm.util.doWhen(doFunc, whenFunc, maxIteration, timeout, fallback, ++iteration);
            }, timeout);
        }
        else if (isFunc(fallback)) {

            fallback();
        }
    }

    static arrayMove(arr, old_index, new_index) {

        if (new_index >= arr.length) {
            let k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    }

    // Adapted from https://stackoverflow.com/questions/60502671/how-to-get-the-date-format-based-on-locale-using-intl-datetimeformat-in-javascri
    static browserDateFormat() {
        if (!this.cachedBrowserDateFormat) {
            const year = 2025;
            const month = 12;
            const day = 15;
            const date = new Date(year, month - 1, day);
            const formattedDate = new Intl.DateTimeFormat(undefined).format(date);
            this.cachedBrowserDateFormat = formattedDate.replace(`${year}`, 'YYYY').replace(`${month}`, 'MM').replace(`${day}`, 'DD');
        }
        return this.cachedBrowserDateFormat;
    }

    static browserDateTimeFormat() {
        if (!this.cachedBrowserDateTimeFormat) {
            const year = 2025;
            const month = 12;
            const day = 15;
            const hour = 22;
            const minute = 50;
            const date = new Date(year, month - 1, day, hour, minute);
            const formattedDate = new Intl.DateTimeFormat(undefined).format(date);
            this.cachedBrowserDateTimeFormat = formattedDate.replace(`${year}`, 'YYYY').replace(`${month}`, 'MM').replace(`${day}`, 'DD') + ' HH:mm tt';
        }
        return this.cachedBrowserDateTimeFormat;
    }
}

Util.cachedBrowserDateFormat = undefined;
Util.cachedBrowserDateTimeFormat = undefined;

cafm.util = Util;